export type AnswerStatus = Readonly<{
    answeredCheckpoints: number;
    answeredCheckpointsNotOK: number;
    totalCheckpoints: number;
    answeredFunctionalElements: number;
    totalFunctionalElements: number;
}>;

export const initialAnswerStatusState: AnswerStatus = {
    answeredCheckpoints: 0,
    answeredCheckpointsNotOK: 0,
    totalCheckpoints: 0,
    answeredFunctionalElements: 0,
    totalFunctionalElements: 0,
};
